export default (axios, checkHeaders) => ({
  getList (data = {}) {
    return axios.get('/product-counts', { params: data.filters || {} })
  },
  postOne (data = {}) {
    return axios.post('/product-count', data.body, { params: data.filters || {} })
  },
  getOne (data = {}) {
    return axios.get('/product-count/' + data.id, { params: data.filters || {} })
  },
  patchOne (data = {}) {
    return axios.patch('/product-count/' + data.id, data.body, { params: data.filters || {} })
  },
  deleteOne (data = {}) {
    return axios.delete('/product-count/' + data.id, { params: data.filters || {} })
  }
})
